import { useCallback } from 'react'
import { FieldValues, FilterOperator } from '../../../types'

type UseFieldOperatorChangeParams = {
  name?: string
  fieldData?: FieldValues[string]
  handleChange?: (value: FieldValues) => void
}

export const useFieldOperatorChange = ({
  name,
  fieldData,
  handleChange
}: UseFieldOperatorChangeParams) => {
  const onChangeOperator = useCallback(
    (operator: FieldValues['']['operator']) => {
      if (!name || fieldData === undefined) {
        return
      }
      let value = fieldData.value
      if (operator === FilterOperator.Filteraction) {
        value = ''
      }
      handleChange?.({
        [name]: {
          ...fieldData,
          value,
          operator
        }
      })
    },
    [name, fieldData, handleChange]
  )

  return { onChangeOperator }
}
